
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.084 1.958H2.917c-1.25 0-2.083.625-2.083 2.083v2.917c0 1.458.833 2.083 2.083 2.083h4.167c1.25 0 2.083-.625 2.083-2.083V4.041c0-1.458-.833-2.083-2.083-2.083zm.196 2.538L5.976 5.537c-.275.221-.625.33-.975.33s-.705-.109-.975-.33L2.72 4.496a.32.32 0 01-.05-.442.312.312 0 01.438-.05l1.304 1.042c.317.254.854.254 1.171 0l1.304-1.042a.308.308 0 01.438.05.316.316 0 01-.046.442z","fill":"#838883"}})])
          )
        }
      }
    